import { isEmpty } from 'lodash';
import {
  VariantCreateRequestApiV2Dto,
  VariantUpdateRequestApiV2Dto,
  VariantDeleteRequestApiV2Dto,
  VariantRequestDto,
} from '@tiendanube/common';
import { LanguagesType } from 'App/i18n';
import { Variant } from 'domains/Catalog/Products/pages/components/Variants/types';
import { variantPayloadBuilder } from '../variantPayloadBuilder/variantPayloadBuilder';

type VariantRequestV2Dto =
  | VariantCreateRequestApiV2Dto
  | VariantUpdateRequestApiV2Dto
  | VariantDeleteRequestApiV2Dto;

export const getUpdateVariantsPayload = (
  language: LanguagesType,
  originalVariants: Variant[],
  newVariants: VariantRequestDto[] | undefined,
): VariantRequestV2Dto[] => {
  if (!newVariants) return [];

  const variantsToCreate: VariantCreateRequestApiV2Dto[] = [];
  const variantsToUpdate: VariantUpdateRequestApiV2Dto[] = [];
  const variantsToDelete: VariantDeleteRequestApiV2Dto[] = [];

  newVariants.forEach((variant) => {
    if (!variant.id) {
      const variantToCreate = variantPayloadBuilder.create(variant, language);
      variantsToCreate.push(variantToCreate);
    } else {
      // TODO: optimize this
      const originalVariant = originalVariants.find((v) => v.id === variant.id);
      if (!originalVariant) return;

      const variantToUpdate = variantPayloadBuilder.update(
        originalVariant,
        variant,
        language,
      );

      if (!isEmpty(variantToUpdate)) {
        variantsToUpdate.push({
          id: Number(variant.id),
          ...variantToUpdate,
        } as VariantUpdateRequestApiV2Dto);
      }
    }
  });

  originalVariants.forEach((variant) => {
    if (!newVariants.find((v) => v.id === variant.id)) {
      variantsToDelete.push(variantPayloadBuilder.delete(variant.id));
    }
  });

  return [...variantsToCreate, ...variantsToUpdate, ...variantsToDelete];
};
